<script>
import { GlobalBus } from '@services/bus'

/**
 * Apresentar um snackbar para feedback no centro da página.
 * Para chamar: $store.dispatch('global/addQueueBigSnack', {text, [timeout, status, close]})
 *
 * @param {String} text Conteúdo para apresentar no snack
 * @param {Number} timeout Tempo para remover o snack. Default: 4000. Opcional.
 * @param {String} status Design para ser utilizado. [success, default, danger, warning]. Default: 'default'. Opcional
 * @param {Boolean} close Apresentar opção para fechar o alerta. Default: true. Opcional.
 */
export default {
  name: 'BigSnackbar',
  data() {
    return {
      show: false,
      snack: {},
      timeoutToClose: null,
    }
  },
  computed: {
    icon() {
      const icons = {
        success: 'mdi-check-circle-outline',
        default: '',
        danger: 'mdi-alert-circle-outline',
        warning: 'mdi-alert-outline',
      }
      return icons[this.snack.status]
    },
  },
  created() {
    GlobalBus.$on('show-big-snackbar', this.showNext)
  },
  beforeDestroy() {
    GlobalBus.$off('show-big-snackbar', this.showNext)
  },
  methods: {
    showNext() {
      if (this.show) {
        // Ja esta apresentando um snack
        return
      }
      // pegar proximo snack
      const snacks = this.$store.getters['global/nextSnack']
      if (snacks && snacks.length) {
        const snack = { ...snacks[0] }
        this.snack = snack
        this.show = true
        // pegar tempo pra tirar
        const timeout = snack.timeout || 4000
        this.timeoutToClose = setTimeout(() => {
          // chamar close
          this.close()
        }, timeout)
        // tirar snack da fila
        this.$store.dispatch('global/removeFirstSnack', snack)
      }
    },
    close() {
      if (!this.show) {
        return
      }
      clearTimeout(this.timeoutToClose)
      this.show = false
      this.$nextTick(() => {
        setTimeout(() => {
          this.showNext()
        }, 200)
      })
    },
  },
}
</script>

<template>
  <v-scale-transition>
    <div
      v-if="show"
      class="big-snackbar elevation-1"
      :class="{
        'snack-success': snack.status === 'success',
        'snack-default': snack.status === 'default' || !snack.status,
        'snack-danger': snack.status === 'danger',
        'snack-warning': snack.status === 'warning',
      }"
    >
      <v-icon v-if="icon" size="24px" style="color: inherit">
        {{ icon }}
      </v-icon>

      <div class="big-snackbar-content">
        {{ snack.text || '' }}
      </div>
      <v-spacer />

      <v-btn
        v-if="snack.close"
        icon
        small
        style="color: inherit"
        @click="close"
      >
        <icon-svg size="12" name="close" style="color: inherit" />
      </v-btn>
    </div>
  </v-scale-transition>
</template>

<style lang="sass">
.big-snackbar
  position: fixed
  bottom: 8px
  left: 0
  right: 0
  border-radius: 8px
  z-index: 1000
  width: 80%
  margin: auto
  display: flex
  align-items: center
  padding: 24px 16px
  font-family: "Open Sans"
  font-weight: 600
  font-size: 14px
  &-content
    margin: 0 16px
  &.snack-success
    background-color: var(--primary)
    color: var(--text-on-primary)
  &.snack-default
    background-color: #333
    color: rgba(255, 255,255,.8)
  &.snack-danger
    background-color: #FFF2F2
    color: #E95656
  &.snack-warning
    background-color: #FFF2EC
    color: #533E35
</style>
